import {useTheme} from "../../contexts/theme";
import Box from "@mui/material/Box";
import PermIdentityIcon from '@mui/icons-material/PermIdentity';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import {FormControl, InputAdornment, Typography} from "@mui/material"
import Logo from "../../assets/images/Login/inbriefFullWhiteR.svg"
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import TextinputField from "../CommonComponents/TextInputField/TextinputField";
import {useAuth} from "../../contexts/auth";
import ErrorSnackBar from "../CommonComponents/ErrorSnackBar/ErrorSnackBar";
import {LoadError} from "../../types/generic";
import TransparentButton from "../CommonComponents/TransparentButton/TransparentButton";

export default function LoginForm() {
    const [credentials, setCredentials] = useState(
        {
            email: "",
            password: ""
        }
    );
    const [loadError, setLoadError] = useState<LoadError>({error: false, message: ''});

    const navigate = useNavigate();
    const theme = useTheme();
    const auth = useAuth();

    function handleChangeEmail(e: React.ChangeEvent<HTMLInputElement>) {
        setCredentials({
                ...credentials, email: e.target.value,
            }
        );
    }

    function handleChangePass(e: React.ChangeEvent<HTMLInputElement>) {
        setCredentials({
                ...credentials, password: e.target.value,
            }
        );
    }

    async function onLoginClick(e: any){
        e.preventDefault();
        try {
            await auth.login(credentials.email, credentials.password);
        } catch (error: any) {
            console.error("Failed to fetch data:", error);

            // Check if the error has a response (which means it came from the backend)
            if (error.response) {
                if (error.response.status === 403) {
                    // Handle specific error codes
                    setLoadError({ error: true, message: 'Incorrect credentials' });
                } else {
                    // Handle other error statuses
                    setLoadError({ error: true, message: error.response.data.message || 'An error occurred' });
                }
            } else {
                // Handle network or other errors
                setLoadError({
                    error: true,
                    message: 'Unable to log in at this time'
                });
            }
        }
    }

    return (

        <Box sx={{
            display: 'flex',
            height: '100vh',
            width: '100vw',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.7)', // Overlay scuro
        }}>

            <ErrorSnackBar autoHideDuration={5000} open={loadError.error}
                           setClose={() => setLoadError({message: '', error: false})} errorMessage={loadError.message}/>

            <Box sx={
                {
                    alignItems: 'center',
                    justifyContent: 'center',
                }
            }>
                <img src={Logo} style={
                    {
                        maxWidth: '150px',  // Limita la larghezza massima dell'immagine
                        height: 'auto',     // Mantiene le proporzioni dell'immagine
                        objectFit: 'contain', // Adatta l'immagine all'interno del contenitore senza distorcerla
                    }
                }></img>

                <Box sx={{
                    borderRadius: theme.border.width.hard,
                    backgroundColor: theme.palette.white,
                    alignItems: 'center',
                    justifyContent: 'center',
                    paddingRight: theme.spacing.md,
                    paddingLeft: theme.spacing.md,
                    paddingTop: theme.spacing.md,
                    paddingBottom: theme.spacing.md

                }}>

                    <Box>
                        <Typography color={theme.palette.black} variant="h5" gutterBottom sx={{
                            fontWeight: theme.fontWeights.value,
                            marginBottom: theme.spacing.md
                        }}>
                            InBrief Sign in
                        </Typography>
                        <form onSubmit={onLoginClick}>
                            <FormControl sx={{
                                minWidth: '400px'
                            }}>
                                <TextinputField placeholder='Email' label={'Email'} type='email' variant={'outlined'}
                                                value={credentials.email}
                                                size={'medium'}
                                                onChange={handleChangeEmail}
                                                name={'email'}
                                                id={"email-outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.black}
                                                borderColor={theme.palette.black}
                                                borderRadius={theme.border.width.hard}
                                                inputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <PermIdentityIcon sx={{
                                                                color: theme.palette.black
                                                            }}/>
                                                        </InputAdornment>
                                                    )
                                                }}/>
                                <TextinputField placeholder='Password' label={'Password'} type='password' variant={'outlined'}
                                                value={credentials.password}
                                                size={'medium'}
                                                onChange={handleChangePass}
                                                name={'password'}
                                                id={"password-outlined-basic"}
                                                borderBottomColor={theme.palette.orange} marginBottom={theme.spacing.md}
                                                backgroundColor={'none'}
                                                color={theme.palette.black}
                                                borderColor={theme.palette.black}
                                                borderRadius={theme.border.width.hard}
                                                inputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <LockOutlinedIcon sx={{
                                                                color: theme.palette.black
                                                            }}/>
                                                        </InputAdornment>
                                                    )
                                                }}/>

                                <Box sx={{
                                display:"flex",
                                justifyContent: 'center',
                                alignItems: 'center'
                                }}
                                >
                                <TransparentButton color={theme.palette.black} type={'submit'} text='Log in' width='50%' login={true}></TransparentButton>
                                </Box>

                            </FormControl></form>
                    </Box>
                </Box>
            </Box>


        </Box>
    );


}